import { useCallback, useMemo } from 'react';

import { SegmentFragment } from '@occc/graphql';

import { SegmentFormValues } from '../../segments.types';
import { useUpdateSegment } from '../../hooks/segments.mutation.hook';

type UseSegmentUpdateControllerParams = {
  segment: SegmentFragment | undefined;
};

export const useSegmentUpdateController = ({ segment }: UseSegmentUpdateControllerParams) => {
  const [updateSegment, { loading: isUpdateInProgress }] = useUpdateSegment({
    refetchQueries: ['segment'],
  });

  const initialFormValues: Partial<SegmentFormValues> = useMemo(() => {
    if (!segment) {
      return {};
    }

    return {
      name: segment.name,
      description: segment.description,
    };
  }, [segment]);

  const onUpdateSubmit = useCallback(
    async (value: SegmentFormValues) => {
      if (!segment) {
        return;
      }

      await updateSegment({
        variables: {
          id: segment.uuid,
          input: {
            name: value.name,
            description: value.description,
          },
        },
      });
    },
    [updateSegment, segment],
  );

  return {
    isUpdateInProgress,
    onUpdateSubmit,
    initialFormValues,
  };
};
